// (function() {
//     'use strict';
    
//     console.log('Optimized cart updater script loaded');
    
//     const CartUpdater = {
//         lastCartToken: null,
//         isUpdating: false,
//         updateQueue: false,
//         lastApiCall: 0,
//         apiCallLimit: 50, // Minimum time between API calls in ms
        
//         // Get cart data from Shopify with rate limiting
//         async getCartData() {
//             const now = Date.now();
//             if (now - this.lastApiCall < this.apiCallLimit) {
//                 console.log('API call rate limited, skipping...');
//                 return null;
//             }
            
//             try {
//                 this.lastApiCall = now;
//                 const response = await fetch('/cart.js');
//                 const data = await response.json();
//                 console.log('Cart API called - Cart data:', data);
//                 return data;
//             } catch (error) {
//                 console.error('Error fetching cart:', error);
//                 return null;
//             }
//         },
        
//         // Format currency
//         formatPrice(cents) {
//             const rupees = cents / 100;
//             return `₹ ${rupees.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
//         },
        
//         // Debounced update to prevent multiple simultaneous updates
//         async updateCartElements() {
//             if (this.isUpdating) {
//                 this.updateQueue = true;
//                 return;
//             }
            
//             this.isUpdating = true;
//             this.updateQueue = false;
            
//             console.log('Updating cart elements...');
            
//             const cartData = await this.getCartData();
//             if (!cartData) {
//                 this.isUpdating = false;
//                 return;
//             }
            
//             // Store cart token to detect changes
//             this.lastCartToken = cartData.token;
            
//             this.updateCartDisplay(cartData);
            
//             this.isUpdating = false;
            
//             // If another update was queued while we were processing, run it now
//             if (this.updateQueue) {
//                 setTimeout(() => this.updateCartElements(), 100);
//             }
//         },
        
//         // Update display without fetching cart data again
//         updateCartDisplay(cartData) {
//             console.log('Updating display with cart data');
            
//             // Update bag counter
//             const bagElement = document.querySelector('.cart_items_custom_qty_bhoopi');
//             const bagElement1 = document.querySelector('#cart-count-bubble');
//             if (bagElement) {
//                 bagElement.innerHTML = `BAG (${cartData.item_count || 0})`;
//             }
//             if (bagElement1) {
//                 bagElement1.innerHTML = `${cartData.item_count || 0}`;
//             }
//             console.log('Updated bag counter:', `(${cartData.item_count || 0})`);
            
//             // Update subtotal (without discounts)
//             const subtotalElement = document.querySelector('.totals__total-value:not(.custom_all_total)');
//             if (subtotalElement) {
//                 const subtotal = cartData.original_total_price || cartData.total_price || 0;
//                 subtotalElement.innerHTML = this.formatPrice(subtotal);
//                 console.log('Updated subtotal');
//             }
            
//             // Update final total (with discounts)
//             const totalElement = document.querySelector('.totals__total-value.custom_all_total');
//             if (totalElement) {
//                 const total = cartData.total_price || 0;
//                 totalElement.innerHTML = this.formatPrice(total);
//                 console.log('Updated total');
//             }
            
//             // Update discount
//             this.updateDiscount(cartData);
//         },
        
//         // Update discount display
//         updateDiscount(cartData) {
//             const originalTotal = cartData.original_total_price || cartData.total_price || 0;
//             const finalTotal = cartData.total_price || 0;
//             const discountAmount = originalTotal - finalTotal;
            
//             const discountContainer = document.querySelector('.discounts__discount--position');
//             const discountAmountElement = document.querySelector('.discount_moneuy_bs_discount_bbhoopi_discount');
            
//             if (discountAmount > 0) {
//                 // Show discount
//                 if (discountContainer) {
//                     discountContainer.style.display = 'flex';
//                 }
//                 if (discountAmountElement) {
//                     discountAmountElement.innerHTML = this.formatPrice(discountAmount);
//                 }
//                 console.log('Updated discount:', this.formatPrice(discountAmount));
//             } else {
//                 // Hide discount
//                 if (discountContainer) {
//                     discountContainer.style.display = 'none';
//                 }
//                 console.log('No discount to show');
//             }
//         },
        
//         // Intercept cart API calls to detect changes - REMOVED AUTOMATIC API CALLS
//         interceptCartRequests() {
//             // Override fetch
//             const originalFetch = window.fetch;
//             window.fetch = async (...args) => {
//                 const response = await originalFetch(...args);
//                 const url = args[0];
                
//                 // Check if it's a cart modification request
//                 if (typeof url === 'string' && (
//                     url.includes('/cart/add') || 
//                     url.includes('/cart/update') || 
//                     url.includes('/cart/change') ||
//                     url.includes('cart/add.js') ||
//                     url.includes('cart/update.js') ||
//                     url.includes('cart/change.js')
//                 )) {
//                     console.log('Cart modification detected via fetch');
//                     // Wait for the operation to complete, then update
//                     setTimeout(() => {
//                         if (response.ok) {
//                             this.updateCartElements();
//                         }
//                     }, 300);
//                 }
                
//                 return response;
//             };
            
//             // Override XMLHttpRequest
//             const originalSend = XMLHttpRequest.prototype.send;
//             XMLHttpRequest.prototype.send = function(...args) {
//                 if (this._url && (
//                     this._url.includes('/cart/add') || 
//                     this._url.includes('/cart/update') || 
//                     this._url.includes('/cart/change') ||
//                     this._url.includes('cart/add.js') ||
//                     this._url.includes('cart/update.js') ||
//                     this._url.includes('cart/change.js')
//                 )) {
//                     this.addEventListener('loadend', () => {
//                         if (this.status >= 200 && this.status < 300) {
//                             console.log('Cart modification detected via XHR');
//                             setTimeout(() => CartUpdater.updateCartElements(), 300);
//                         }
//                     });
//                 }
//                 return originalSend.apply(this, args);
//             };
            
//             const originalOpen = XMLHttpRequest.prototype.open;
//             XMLHttpRequest.prototype.open = function(method, url, ...args) {
//                 this._url = url;
//                 return originalOpen.apply(this, [method, url, ...args]);
//             };
//         },
        
//         // Debounce function for event listeners
//         debounce(func, wait) {
//             let timeout;
//             return function executedFunction(...args) {
//                 const later = () => {
//                     clearTimeout(timeout);
//                     func(...args);
//                 };
//                 clearTimeout(timeout);
//                 timeout = setTimeout(later, wait);
//             };
//         },
        
//         // Setup event listeners with debouncing
//         setupListeners() {
//             console.log('Setting up listeners...');
            
//             // Debounced update function
//             const debouncedUpdate = this.debounce(() => this.updateCartElements(), 500);
            
//             // Listen for Shopify cart events
//             const events = ['cart:updated', 'cart:changed', 'cartUpdated'];
//             events.forEach(event => {
//                 document.addEventListener(event, () => {
//                     console.log('Cart event detected:', event);
//                     debouncedUpdate();
//                 });
//             });
            
//             // Listen for clicks on cart buttons (debounced)
//             document.addEventListener('click', this.debounce((e) => {
//                 const target = e.target;
//                 if (target.matches('.add-to-cart, [data-cart-add], .btn-cart, .quantity-selector') ||
//                     target.closest('.add-to-cart, [data-cart-add], .btn-cart, .quantity-selector, form[action*="/cart/add"]')) {
//                     console.log('Cart button clicked');
//                     setTimeout(() => this.updateCartElements(), 600);
//                 }
//             }, 300));
            
//             // Listen for form submissions (debounced)
//             document.addEventListener('submit', this.debounce((e) => {
//                 if (e.target.action && e.target.action.includes('/cart/add')) {
//                     console.log('Cart form submitted');
//                     setTimeout(() => this.updateCartElements(), 600);
//                 }
//             }, 300));
            
//             // REMOVED the frequent polling interval!
//             // Only check for changes every 30 seconds as emergency backup
//             setInterval(() => {
//                 // Only check if no recent activity
//                 const timeSinceLastCall = Date.now() - this.lastApiCall;
//                 if (timeSinceLastCall > 25000) { // 25 seconds since last API call
//                     console.log('Emergency backup check...');
//                     this.updateCartElements();
//                 }
//             }, 30000); // 30 seconds instead of 100ms!
//         },
        
//         // Initialize
//         init() {
//             console.log('Initializing optimized cart updater...');
//             this.updateCartElements();
//             this.interceptCartRequests();
//             this.setupListeners();
//         }
//     };
    
//     // Start when DOM is ready
//     if (document.readyState === 'loading') {
//         document.addEventListener('DOMContentLoaded', () => CartUpdater.init());
//     } else {
//         CartUpdater.init();
//     }
    
//     // Backup on window load
//     window.addEventListener('load', () => CartUpdater.init());
    
//     // Expose for debugging
//     window.CartUpdater = CartUpdater;
    
// })();



(function() {
    'use strict';
    
    console.log('Optimized cart updater script loaded');
    
    const CartUpdater = {
        lastCartToken: null,
        isUpdating: false,
        updateQueue: false,
        lastApiCall: 0,
        apiCallLimit: 50, // Minimum time between API calls in ms
        
        // Get cart data from Shopify with rate limiting
        async getCartData() {
            const now = Date.now();
            if (now - this.lastApiCall < this.apiCallLimit) {
                console.log('API call rate limited, skipping...');
                return null;
            }
            
            try {
                this.lastApiCall = now;
                const response = await fetch('/cart.js');
                const data = await response.json();
                console.log('Cart API called - Cart data:', data);
                return data;
            } catch (error) {
                console.error('Error fetching cart:', error);
                return null;
            }
        },
        
        // Format currency
        formatPrice(cents) {
            const rupees = cents / 100;
            return `₹ ${rupees.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        },
        
        // Debounced update to prevent multiple simultaneous updates
        async updateCartElements() {
            if (this.isUpdating) {
                this.updateQueue = true;
                return;
            }
            
            this.isUpdating = true;
            this.updateQueue = false;
            
            console.log('Updating cart elements...');
            
            const cartData = await this.getCartData();
            if (!cartData) {
                this.isUpdating = false;
                return;
            }
            
            // Store cart token to detect changes
            this.lastCartToken = cartData.token;
            
            this.updateCartDisplay(cartData);
            
            this.isUpdating = false;
            
            // If another update was queued while we were processing, run it now
            if (this.updateQueue) {
                setTimeout(() => this.updateCartElements(), 100);
            }
        },
        
        // Update display without fetching cart data again
        updateCartDisplay(cartData) {
            console.log('Updating display with cart data');
            
            // Update bag counter
            const bagElement = document.querySelector('.cart_items_custom_qty_bhoopi');
            const bagElement1 = document.querySelector('#cart-count-bubble');
            if (bagElement) {
                bagElement.innerHTML = `BAG (${cartData.item_count || 0})`;
            }
            if (bagElement1) {
                bagElement1.innerHTML = `${cartData.item_count || 0}`;
            }
            console.log('Updated bag counter:', `(${cartData.item_count || 0})`);
            
            // Update subtotal (without discounts)
            const subtotalElement = document.querySelector('.totals__total-value:not(.custom_all_total)');
            if (subtotalElement) {
                const subtotal = cartData.original_total_price || cartData.total_price || 0;
                subtotalElement.innerHTML = this.formatPrice(subtotal);
                console.log('Updated subtotal');
            }
            
            // Update final total (with discounts)
            const totalElement = document.querySelector('.totals__total-value.custom_all_total');
            if (totalElement) {
                const total = cartData.total_price || 0;
                totalElement.innerHTML = this.formatPrice(total);
                console.log('Updated total');
            }
            
            // Update discount
            this.updateDiscount(cartData);
        },
        
        // Update discount display
        updateDiscount(cartData) {
            const originalTotal = cartData.original_total_price || cartData.total_price || 0;
            const finalTotal = cartData.total_price || 0;
            const discountAmount = originalTotal - finalTotal;
            
            const discountContainer = document.querySelector('.discounts__discount--position');
            const discountAmountElement = document.querySelector('.discount_moneuy_bs_discount_bbhoopi_discount');
            
            if (discountAmount > 0) {
                // Show discount
                if (discountContainer) {
                    discountContainer.style.display = 'flex';
                }
                if (discountAmountElement) {
                    discountAmountElement.innerHTML = this.formatPrice(discountAmount);
                }
                console.log('Updated discount:', this.formatPrice(discountAmount));
            } else {
                // Hide discount
                if (discountContainer) {
                    discountContainer.style.display = 'none';
                }
                console.log('No discount to show');
            }
        },
        
        // Intercept cart API calls to detect changes
        interceptCartRequests() {
            // Override fetch
            const originalFetch = window.fetch;
            window.fetch = async (...args) => {
                const response = await originalFetch(...args);
                const url = args[0];
                
                // Check if it's a cart modification request
                if (typeof url === 'string' && (
                    url.includes('/cart/add') || 
                    url.includes('/cart/update') || 
                    url.includes('/cart/change') ||
                    url.includes('cart/add.js') ||
                    url.includes('cart/update.js') ||
                    url.includes('cart/change.js')
                )) {
                    console.log('Cart modification detected via fetch');
                    // Wait for the operation to complete, then update
                    setTimeout(() => {
                        if (response.ok) {
                            this.updateCartElements();
                        }
                    }, 300);
                }
                
                return response;
            };
            
            // Override XMLHttpRequest
            const originalSend = XMLHttpRequest.prototype.send;
            XMLHttpRequest.prototype.send = function(...args) {
                if (this._url && (
                    this._url.includes('/cart/add') || 
                    this._url.includes('/cart/update') || 
                    this._url.includes('/cart/change') ||
                    this._url.includes('cart/add.js') ||
                    this._url.includes('cart/update.js') ||
                    this._url.includes('cart/change.js')
                )) {
                    this.addEventListener('loadend', () => {
                        if (this.status >= 200 && this.status < 300) {
                            console.log('Cart modification detected via XHR');
                            setTimeout(() => CartUpdater.updateCartElements(), 300);
                        }
                    });
                }
                return originalSend.apply(this, args);
            };
            
            const originalOpen = XMLHttpRequest.prototype.open;
            XMLHttpRequest.prototype.open = function(method, url, ...args) {
                this._url = url;
                return originalOpen.apply(this, [method, url, ...args]);
            };
        },
        
        // Debounce function for event listeners
        debounce(func, wait) {
            let timeout;
            return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        },
        
        // Setup event listeners with debouncing
        setupListeners() {
            console.log('Setting up listeners...');
            
            const debouncedUpdate = this.debounce(() => this.updateCartElements(), 500);
            
            const events = ['cart:updated', 'cart:changed', 'cartUpdated'];
            events.forEach(event => {
                document.addEventListener(event, () => {
                    console.log('Cart event detected:', event);
                    debouncedUpdate();
                });
            });
            
            document.addEventListener('click', this.debounce((e) => {
                const target = e.target;
                if (target.matches('.add-to-cart, [data-cart-add], .btn-cart, .quantity-selector') ||
                    target.closest('.add-to-cart, [data-cart-add], .btn-cart, .quantity-selector, form[action*="/cart/add"]')) {
                    console.log('Cart button clicked');
                    setTimeout(() => this.updateCartElements(), 600);
                }
            }, 300));
            
            document.addEventListener('submit', this.debounce((e) => {
                if (e.target.action && e.target.action.includes('/cart/add')) {
                    console.log('Cart form submitted');
                    setTimeout(() => this.updateCartElements(), 600);
                }
            }, 300));
            
            // Emergency backup check every 30s
            setInterval(() => {
                const timeSinceLastCall = Date.now() - this.lastApiCall;
                if (timeSinceLastCall > 25000) {
                    console.log('Emergency backup check...');
                    this.updateCartElements();
                }
            }, 30000);
        },
        
        // Initialize
        init() {
            console.log('Initializing optimized cart updater...');
            this.updateCartElements();
            this.interceptCartRequests();
            this.setupListeners();
        }
    };
    
    // 🧩 Prevent navigation to /cart — open slide cart instead
    document.addEventListener('click', function(e) {
        const target = e.target.closest('a[href="/cart"], a[href="/cart/"], [data-cart-link]');
        if (target) {
            e.preventDefault();
            console.log('Prevented /cart navigation — opening slide cart instead');
            if (typeof window.HS_SLIDE_CART_OPEN === 'function') {
                window.HS_SLIDE_CART_OPEN();
            } else {
                console.warn('HS_SLIDE_CART_OPEN function not found!');
            }
        }
    });

    // Also override "Go to Cart" inside drawers if needed
    document.addEventListener('click', function(e) {
        const target = e.target.closest('.go-to-cart, .view-cart');
        if (target && target.tagName === 'A' && target.href.includes('/cart')) {
            e.preventDefault();
            console.log('Overrode internal cart link');
            if (typeof window.HS_SLIDE_CART_OPEN === 'function') {
                window.HS_SLIDE_CART_OPEN();
            }
        }
    });
    
    // Start when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => CartUpdater.init());
    } else {
        CartUpdater.init();
    }
    
    // Backup on window load
    window.addEventListener('load', () => CartUpdater.init());
    
    // Expose for debugging
    window.CartUpdater = CartUpdater;
    
})();
